import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import GeneralServices from '../../app/service/generalServices'
import LancarFechamentoBancarioService from '../../app/service/conciliacaoBancaria/lancarFechamentoBancarioService'
import ConstantsUtil from '../../context/constantsUtil'
import { classNames } from 'primereact/utils'
import { Dialog } from 'primereact/dialog'
import FichaDeRecebimentoTable from './fichaDeRecebimentoTable'
import HandleErrorService from '../../app/service/handleErrorService'
import FichaDeRecebimentoService from '../../app/service/contasAReceber/fichaDeRecebimentoService'
import { Button } from 'primereact/button'
import TableFilters from '../tableFilters'
import * as popUp from '../toastr'


class FichaDeRecebimentoConsolidadaTable extends React.Component {
    
    constructor() {
        super();
        this.dt = React.createRef();
        this.lancarFechamentoBancarioService = new LancarFechamentoBancarioService();
        this.fichaDeRecebimentoService = new FichaDeRecebimentoService()
        this.tableFilters = new TableFilters()
    
    }

    state = {
        
        fichaDeRecebimentoToView: {},
        displayFichaBancariaIndividualDialog: false,
        loading: false,

    }

    componentDidMount(){
        // console.log("componentDidMount FichaDeRecebimentoConsolidadaTable")
        this.setProps()
    }

    setProps = () => {
        // console.log('setProps: ', this.props.fichaDeRecebimento, this.props.fichaDeRecebimento.doAutoSearch)
        // console.log("this.props.fichaDeRecebimento inicial: ", this.props.fichaDeRecebimento)
        if(this.props.fichaDeRecebimento && this.props.fichaDeRecebimento.doAutoSearch) {
            this.doAutoSearch()
        }
    }
    
    doAutoSearch = () => {
        // console.log("doAutoSearch: ", this.props.specificEmpresaId)
        this.setState({loading: true})

        let extraHeaderObj= null
        if(this.props.specificEmpresaId) {
            extraHeaderObj = {specificEmpresaId: this.props.specificEmpresaId}
        }

        this.fichaDeRecebimentoService.getFichaConsolidadaByDateInterval(
            {
                initialLancamentoDate : this.props.fichaDeRecebimento.initialDate,
                finalLancamentoDate : this.props.fichaDeRecebimento.finalDate,
                dateFilterType : this.props.fichaDeRecebimento.dateFilterType,
                sortType: this.props.sortType ? this.props.sortType : ''
            },
            extraHeaderObj
        )
        .then(response => {
            if(this.props.updateProps){
                this.props.updateProps(response.data)
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }        

    beginLoadingFichaDeRecebimentoTable = () => {
        this.setState({loading: true})
    }

    endLoadingFichaDeRecebimentoTable = () => {
        this.setState({loading: false})
    }

    getTableHeaders = () => {
        // console.log("getTableHeaders")
        const periodo = this.props.fichaDeRecebimento && this.props.fichaDeRecebimento.initialDate ? this.props.fichaDeRecebimento.initialDate + " - " + this.props.fichaDeRecebimento.finalDate : ""
        const periodoLabel = "Período: " + periodo

        const dateFilterType = this.props.fichaDeRecebimento && this.props.fichaDeRecebimento.dateFilterType ? this.props.fichaDeRecebimento.dateFilterType : ''
        const dateFilterTypeLabel = "Filtrado por: " + dateFilterType

        return {dateFilterType: dateFilterTypeLabel, periodo: periodoLabel}
    }

    rowClass(rowData) {
        return {
            [ConstantsUtil.totaisTableLabel]: rowData.nomeTipoDeRecebimento === ConstantsUtil.tipoTotaisFichaDeRecebimentoLabel
        }
    }

    viewFichaDeRecebimentoIndividual = rowData => {
        // console.log("viewFichaDeRecebimentoIndividual: ", rowData)
        // console.log("this.props.fichaDeRecebimento: ", this.props.fichaDeRecebimento)
        // console.log("this.state: ", this.state)

        if(!rowData.id && rowData.tipoLancamento === ConstantsUtil.tipoTotaisFichaDeRecebimentoLabel){
            return
        }

        let fichaDeRecebimentoToView = JSON.parse(JSON.stringify(this.props.fichaDeRecebimento))
        
        fichaDeRecebimentoToView.tipoDeRecebimento = {
            id: rowData.id,
            nomeTipoDeRecebimento: rowData.nomeTipoDeRecebimento,
            grupoDeRecebimento: rowData.grupoDeRecebimento,
        }

        fichaDeRecebimentoToView.tipoLancamento = rowData.tipoLancamento

        this.setState({fichaDeRecebimentoToView})
        this.setState({displayFichaBancariaIndividualDialog: true})
        this.setState({forceUpdateDialog: true})
    }

    hideDialog = () => {
        this.setState({fichaDeRecebimentoToView: {}})
        this.setState({displayFichaBancariaIndividualDialog: false})        
    }

    getMappedItemToExport = (item) => {
        
        // console.log("item: ", item)
        // console.log("empresa: ", this.props.specificEmpresaId)

        let mappedItem = {
            ['Tipo de Recebimento']: item.nomeTipoDeRecebimento,
            ['Valor Bruto']: GeneralServices.formatTo2CasasDecimais(item.valorBruto),
            ['Comissão']: GeneralServices.formatTo2CasasDecimais(item.comissao),
            ['Valor Líquido']: GeneralServices.formatTo2CasasDecimais(item.valorLiquido),
        }

        return mappedItem

    }

    getListToExport = () => {

        let exportList = this.getList().map(item => {
            return this.getMappedItemToExport(item)
        })

        return exportList
    }

    getFilenameToExport = () => {
        // console.log("getFilenameToExport: ", this.props)
        let header = this.props.header ? this.props.header : 'Taxas de Cartões'
        if(this.props.nomeEmpresa){
            header += ` - ${this.props.nomeEmpresa}`
        }
        return header
    }

    exportXLSX = () => {
        // console.log("itemDre: ", this.props.itemDre)
        // console.log("grupoDre: ", this.props.grupoDre)
        let exportList = this.getListToExport()
        GeneralServices.exportExcel(exportList, "Taxas de Cartões", this.getFilenameToExport())
    }

    getList = () => {
        return this.props.fichaDeRecebimento ? this.props.fichaDeRecebimento.lancamentos : []
    }

    render (){

        const renderNomeTipoDeRecebimentoLink = (rowData) => {
            const classes = classNames({
                'linkValue': true
                
            });
            return(
                <a
                    className={classes}
                    // href='/DRE'
                    onClick={() => this.viewFichaDeRecebimentoIndividual(rowData)}
                >
                    {rowData.nomeTipoDeRecebimento}
                </a>
            )            
        }

        const renderFichaBancariaIndividualDialog = () => {
            return (
                <Dialog
                    visible={this.state.displayFichaBancariaIndividualDialog}
                    style={{ width: '95vw' }}
                    header={`Ficha de Recebimento Individual (${this.state.fichaDeRecebimentoToView.tipoDeRecebimento ? this.state.fichaDeRecebimentoToView.tipoDeRecebimento.nomeTipoDeRecebimento : ""})`}
                    modal
                    className="p-fluid"
                    // footer={chooseContaBancariaDialogFooter}
                    onHide={this.hideDialog}
                >

                <FichaDeRecebimentoTable
                    fichaDeRecebimento={this.state.fichaDeRecebimentoToView}
                    doAutoSearch
                    insideDialog
                />

                </Dialog>
            )
        }

        if(this.props.isExportacaoAutomatica){
            return (
                <></>
            )
        }

        const nomeTipoDeRecebimentoFilterElement =
        this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNome,
            this.getList(),
            "selectedNome",
            (name, value) => this.setState({[name]: value}),
            'nomeTipoDeRecebimento',
            '100%',
            "Nome"
        )

        return (
            <>
            <div className = "card-header">
                <div className='col-md-12'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <h5 className='medium-font-size'>{this.getTableHeaders().dateFilterType}</h5>
                        </div>
                        <div className='col-md-4'>
                            <h5 className='medium-font-size'>{this.getTableHeaders().periodo}</h5>
                        </div>
                        <div className='col-md-4'>
                            <Button
                                label="Exportar"
                                icon="pi pi-file-excel"
                                className="p-button-success small-font small-button"
                                onClick={this.exportXLSX}
                                tooltip={ConstantsUtil.exportXlsxLabel}
                                tooltipOptions={{position: 'top'}}
                            />                            
                        </div>
                    </div>
                    
                </div>
            </div>
            
            <div className="">
                <DataTable
                    ref={this.dt}
                    value={this.getList()}
                    className="p-datatable-sm small-font"
                    loading={this.props.loading || this.state.loading}
                    rowClassName={this.rowClass}
                    showGridlines
                    rowHover
                    scrollable
                    scrollHeight={this.props.insideDialog ? "50vh" : "500px"}
                    emptyMessage={ConstantsUtil.nenhumLancamentoEncontradoMessage}
                    dataKey="id"
                    // paginator rows={10} rowsPerPageOptions={[5, 10, 25]}
                    // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    // currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} movimentações"
                >

                    <Column
                        header="Tipo de Recebimento"
                        field="nomeTipoDeRecebimento"
                        style ={ {width: '140px'} }
                        body={renderNomeTipoDeRecebimentoLink}
                        filter filterElement={nomeTipoDeRecebimentoFilterElement}
                    />

                    <Column 
                        header="Bruto"
                        field="valorBruto"
                        body = {rowData => GeneralServices.showFormattedIfNonZero(rowData.valorBruto, true) }
                        style ={ {width: '100px'} }
                    />

                    <Column
                        header="Comissão"
                        field="comissao" 
                        body = {rowData => GeneralServices.showFormattedIfNonZero(rowData.comissao, true) }
                        style ={ {width: '100px'} }
                    />

                    <Column 
                        header="Líquido"
                        field="valorLiquido" 
                        body = {rowData => GeneralServices.showFormattedIfNonZero(rowData.valorLiquido, true) }
                        style ={ {width: '100px'} }
                    />

                    <Column
                        header="Crédito"
                        field="credito" 
                        body = {rowData => GeneralServices.showFormattedIfNonZero(rowData.credito, true) }
                        style ={ {width: '100px'} }
                    />

                    <Column
                        header="Ajuste"
                        field="ajuste"
                        body = {rowData =>
                            GeneralServices.showFormattedIfNonZero(rowData.ajuste, true) 
                        }
                        style ={ {width: '100px'} }
                    />

                    <Column
                        header="Saldo"
                        field="saldo"
                        body = {rowData => GeneralServices.showFormattedIfNotNull(rowData.saldo, true) }
                        style ={ {width: '100px'} } 
                    />

                </DataTable>
            </div>

            {renderFichaBancariaIndividualDialog()}

            </>
        )
    }


}  

export default FichaDeRecebimentoConsolidadaTable